<template>
  <el-dialog
    title="异常改签-选择班次"
    :visible.sync="visibile"
    width="66%"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="20">
        <!-- 当前日期： -->
        <!-- <el-date-picker
            v-model="dateValue"
            type="date"
            placeholder="选择日期"
            format="MM 月 dd 日"
            value-format="yyyy-MM-dd"
            style="width: 14vw" @change="handleDate">
        </el-date-picker> -->
        <el-form ref="query" :model="query" :inline="true" label-width="90px" size="mini">
          <el-form-item label="当前日期：" prop="merchantId">
            <el-date-picker
              v-model="query.dateValue"
              type="date"
              placeholder="选择日期"
              format="MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 179px"
              @change="handleDate"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item label="供应商：" prop="merchantId">
            <el-select
              v-model="query.merchantId"
              filterable
              placeholder="请选择供应商"
              clearable
              @change="merchantChange"
            >
              <el-option
                v-for="item in merchantDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="发车时间：" prop="time">
            <yd-common-selector
              v-model="query.time"
              placeholder="请选择时间"
              :options="departureTime"
              @change="handleDepartureTimeChange"
            />
          </el-form-item>
        </el-form>

        <div class="tipsBox">
          <img style="vertical-align: middle; width: 20px; height: 20px" src="./static/tips.png" />
          <span>选择改签日期后可查看班次，点击班次后的“改签”进入确认行程信息页面！</span>
        </div>
      </el-col>
    </el-row>
    <el-table :data="data" size="small" border max-height="280">
      <el-table-column label="班次ID" align="center" width="90" prop="id" />
      <el-table-column label="发车时间" align="center" width="180" prop="departureDate">
        <template slot-scope="scope">
          <div v-if="scope.row.adjustTime < 0">
            {{ scope.row.otherDate }} {{ scope.row.otherTime }} -
            <div v-if="scope.row.spanDay === 0">{{ scope.row.departureTime }}</div>
            <div v-else>{{ scope.row.departureDate + '   ' + scope.row.departureTime }}</div>
          </div>
          <div v-else>
            {{ scope.row.departureDate + '   ' + scope.row.departureTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="doorTime"
        label="乘客端展示时间段(门到门模式)"
        min-width="220"
        align="center"
      />
      <el-table-column label="司机信息" align="center" width="150" prop="driverName">
        <template slot-scope="scope">
          {{ scope.row.driverName + ' ' + scope.row.driverPhone }}
        </template>
      </el-table-column>
      <el-table-column label="车辆信息" align="center" width="100" prop="plateNumber" />
      <el-table-column label="余票（张）" align="center" width="90" prop="ticketSurplus" />
      <el-table-column label="标签" align="center" width="120" prop="labelStr" />
      <el-table-column label="供应商" align="center" width="120" prop="merchantName" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click.stop="handleChange(scope.row)"
            :disabled="disabled(scope.row)"
          >
            改签
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-if="page.total > 0"
      :total="page.total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="resfresh"
    />
    <!--    异常改签保险bug-->
    <ticket-details
      v-if="ticketDialogVisible"
      ref="ticketDialog"
      :insureDates="insureDateList"
      @refresh="$emit('refresh')"
    />
  </el-dialog>
</template>

<script>
  import { getPage, getMerchant, flightPlanTime } from '@/api/transport/ticketsche'
  import { check } from '@/api/intercityorder'
  import ticketDetails from './change-ticket-details'
  import dayjs from 'dayjs'
  export default {
    name: 'changeTicket',
    props: {
      insureDateList: {
        type: Array,
        default() {
          return []
        }
      },
      changeEndTime: {
        type: String,
        default: ''
      }
    },
    components: {
      ticketDetails
    },
    data() {
      return {
        query: {
          dateValue: '',
          merchantId: '',
          time: ''
        },
        ticketDialogVisible: false,
        visibile: false,
        dateValue: '',
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        info: {},
        data: [],
        merchantDic: [],
        merchantIds: [],
        departureTime: [],
        pickerOptions: {
          disabledDate: (time) => {
            // 使用dayjs获取changeEndTime的日期作为最后可选择日期
            const today = dayjs().startOf('day')
            const endDate = dayjs(this.changeEndTime).endOf('day')

            return dayjs(time).isBefore(today) || dayjs(time).isAfter(endDate)
          }
        }
      }
    },
    computed: {
      disabled() {
        return (row) => {
          const { modeType } = this.info
          let date
          if (modeType === 2) {
            // 门对门模式取preferredDepartureStart
            date = row.preferredDepartureStart
          } else {
            date = row.departureDate + ' ' + row.departureTime
          }
          // 判断发车时间是否大于最晚改签时间
          return dayjs(date).isAfter(dayjs(this.changeEndTime))
        }
      }
    },
    watch: {
      visibile() {
        if (!this.visibile) {
          this.query.time = ''
        }
      }
    },
    methods: {
      init(row) {
        this.visibile = true
        this.info = row
        this.query.dateValue = this.dateFormatVar(new Date())
        this.query.merchantId = this.info.merchantId
        this.$nextTick(() => {
          // this.onLoad(this.page)
          this.handleGetMerchant()
        })
        this.getFlightPlanTime()
      },
      resfresh() {
        this.onLoad(this.page)
      },
      onLoad(page, params = {}) {
        this.$loading()
        this.data = []
        // const { pickUpInfo } = this.info
        // const pickupOrder = pickUpInfo.find((item) => item.pickupType === '接人') || {}
        const adonData = {
          current: this.page.current,
          size: this.page.size,
          departureIds: [Number.parseInt(this.info.departureStationId)],
          destinationIds: [Number.parseInt(this.info.destinationStationId)],
          merchantIds: this.merchantIds,
          startDate: this.query.dateValue,
          time: '',
          orderId: this.info.orderId
        }
        // // 如果日期为当天，则设置时间为当前时间
        // if (dayjs(this.query.dateValue).isSame(dayjs(), 'day')) {
        //   adonData.time = dayjs().format('HH:mm:ss')
        // }

        getPage(Object.assign(adonData, params))
          .then((resp) => {
            const arr = resp.data.records || []
            this.data = arr.map((item) => {
              const { preferredDepartureStart, preferredDepartureEnd, ...rest } = item
              let timeStr = '-'
              if (preferredDepartureEnd && preferredDepartureEnd) {
                const date = dayjs(preferredDepartureStart).format('YYYY-MM-DD')
                const startTime = dayjs(preferredDepartureStart).format('HH:mm')
                const endTime = dayjs(preferredDepartureEnd).format('HH:mm')
                timeStr = `${date} ${startTime}-${endTime}`
              }
              return {
                doorTime: timeStr,
                preferredDepartureStart,
                preferredDepartureEnd,
                ...rest
              }
            })
            this.page.total = resp.data.total
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleGetMerchant() {
        getMerchant(this.info.lineId).then((res) => {
          const { code, data } = res
          if (code === 0 && data) {
            this.merchantIds.push(this.info.merchantId)
            this.merchantDic = data
            this.onLoad(this.page)
          }
        })
      },
      merchantChange(val) {
        if (val) {
          this.merchantIds = []
          this.merchantIds.push(val)
          this.onLoad(this.page)
        }
      },
      handleDate(val) {
        const adonData = {
          current: this.page.current,
          size: this.page.size,
          departureIds: [Number.parseInt(this.info.departureStationId)],
          destinationIds: [Number.parseInt(this.info.destinationStationId)],
          merchantIds: [Number.parseInt(this.query.merchantId)],
          startDate: val
        }
        this.onLoad(this.page, adonData)
      },
      handleChange(row) {
        this.ticketDialogVisible = true
        check({ sectionId: row.id, seatDtos: [], oldOrderId: this.info.orderId }).then((resp) => {
          if (resp.data === '') {
            this.$nextTick(() => {
              this.$refs.ticketDialog.init(row, this.info)
            })
          } else {
            this.$confirm(resp.data, {
              showConfirmButton: false,
              cancelButtonText: '我知道了',
              type: 'warning'
            }).then(() => {
              this.$nextTick(() => {
                this.$refs.ticketDialog.init(row, this.info)
              })
            })
          }
        })
      },
      dateFormatVar(date) {
        let format = 'yyyy-MM-dd'
        if (date !== 'Invalid Date') {
          const o = {
            'M+': date.getMonth() + 1, // month
            'd+': date.getDate(), // day
            'h+': date.getHours(), // hour
            'm+': date.getMinutes(), // minute
            's+': date.getSeconds(), // second
            'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
            S: date.getMilliseconds() // millisecond
          }
          if (/(y+)/.test(format))
            format = format.replace(
              RegExp.$1,
              (date.getFullYear() + '').substr(4 - RegExp.$1.length)
            )
          for (const k in o)
            if (new RegExp('(' + k + ')').test(format))
              format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
              )
          return format
        }
        return ''
      },
      // 获取指定日期线路下的发车时间
      async getFlightPlanTime() {
        const { code, data } = await flightPlanTime({
          departureIds: [Number.parseInt(this.info.departureStationId)],
          destinationIds: [Number.parseInt(this.info.destinationStationId)],
          merchantIds: this.merchantIds,
          startDate: this.query.dateValue
        })
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.departureTime = data.map((it) => {
          return {
            ...it,
            label: it.flightPlanTime,
            value: it.flightPlanId
          }
        })
      },
      handleDepartureTimeChange(v) {
        this.onLoad(this.page, {
          time: !v || Reflect.ownKeys(v).length < 2 ? '' : v.flightPlanTime + ':00'
        })
      }
    }
  }
</script>

<style scoped>
  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }
  .tipsBox span {
    margin-left: 5px;
  }
</style>
